// extracted by mini-css-extract-plugin
module.exports = {"d1w7h81e":"d1w7h81e","dyiyxgq":"dyiyxgq"};